import MainLayout from '@/shared/Layouts/MainLayout'
import css from './organizationUsers.module.css'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import CreateUserSidePage from '@/pages/Users/components/CreateUserSidePage'
import ProtectedContent from '@/services/rights/ProtectedContent'
import OrganizationUsersReportView from './components/OrganizationUsersReportView'
import BadgeCount from '@/shared/Badges/BadgeCount'
import DropdownMultiFilterChips from '@/shared/Inputs/FilterChips/DropdownMultiFilterChips'
import { IOption } from '@/types/global'
import DropdownFilterChips from '@/shared/Inputs/FilterChips/DropdownFilterChips'
import OrganizationUsersTable from '@/pages/Users/components/OrganiaztionUsersTable'
import useMyOrganizationUsersCtrl from './hooks/useMyOrganizationUsersCtrl'
import Segmented from '@/shared/Common/Segmented'
import useTitle from '@/shared/hooks/useTitle'

const userActiveOptions: IOption<number>[] = [
  { title: 'Деактивированные', value: 0 },
  { title: 'Активированные', value: 1 },
]

const MyOrganizationUsers = () => {
  useTitle('Сотрудники')
  const ctrl = useMyOrganizationUsersCtrl()

  const renderContent = () => {
    switch (ctrl.data.viewingMode) {
      case 'list':
        return (
          <div className={css.tableWrapper}>
            <OrganizationUsersTable
              organizationId={ctrl.data.organizationId}
              positionFilter={ctrl.data.positionFilter}
              activeFilter={ctrl.data.activeFilter}
            />
          </div>
        )
      case 'report':
        return (
          <div style={{ height: 'calc(100% - 34px - 32px - 24px - 16px)' }}>
            <OrganizationUsersReportView users={ctrl.data.users} usersLoading={ctrl.data.usersLoading} />
          </div>
        )
    }
  }

  return (
    <>
      <MainLayout>
        <div className={css.wrapper}>
          <div className={css.main}>
            <div className="flex-lines gap16 height100">
              <div className="flex-lines gap24">
                <div className="inline-flex-gap gap24">
                  <div className="inline-flex-gap gap8 center">
                    <h2 className="text-heading-3">Сотрудники</h2>
                    <BadgeCount type="default" count={ctrl.data.users.length} loading={ctrl.data.usersLoading} />
                  </div>
                  <ProtectedContent requiredRight="users:create">
                    <CreateEntityButton
                      onClick={() => ctrl.handlers.handleCreateUserSidePageOpen(true)}
                      text="Добавить сотрудника"
                    />
                  </ProtectedContent>
                </div>
                <div className="flex-space-between">
                  <div className="inline-flex-gap gap16 center">
                    <div style={{ flexShrink: 0 }}>
                      <DropdownMultiFilterChips
                        name="positions"
                        selectedOptions={ctrl.data.positionFilter}
                        title="Должность"
                        options={ctrl.data.positionOptions}
                        style={{ minWidth: '140px' }}
                        panelStyle={{ width: '360px', left: 0 }}
                        onSelect={ctrl.handlers.handlePositionFilterChange}
                      />
                    </div>
                    <div style={{ flexShrink: 0 }}>
                      <DropdownFilterChips
                        name="active"
                        selectedOption={ctrl.data.activeFilter}
                        title="Активность"
                        options={userActiveOptions}
                        style={{ minWidth: '140px' }}
                        panelStyle={{ width: '360px', left: 0 }}
                        onSelect={ctrl.handlers.handleActiveFilterChange}
                      />
                    </div>
                  </div>
                  <Segmented
                    style={{ width: 'fit-content' }}
                    size="middle"
                    block
                    value={ctrl.data.viewingMode}
                    options={[
                      { value: 'list', label: 'Список' },
                      { value: 'report', label: 'Отчет' },
                    ]}
                    onChange={ctrl.handlers.switchViewingMode}
                  />
                </div>
              </div>
              {renderContent()}
            </div>
          </div>
        </div>
      </MainLayout>
      <CreateUserSidePage
        open={ctrl.data.createUserSidePageOpen}
        organizationId={ctrl.data.organizationId}
        onClose={() => ctrl.handlers.handleCreateUserSidePageOpen(false)}
      />
    </>
  )
}

export default MyOrganizationUsers
